import React from "react";

function NotFound() {
  return (
    <>
      <title>Not Found Page</title>
      <meta name="description" content="Not Found Page to the Office" />
      <div className="container mx-auto">
        <div className="flex justify-center items-center h-[80vh]">
          <h1 class="text-4xl font-bold text-center text-black">
            404 <br /> Not Found
          </h1>
        </div>
      </div>
    </>
  );
}

export default NotFound;
